export const ACTIVITY_NAME_ACCESSORIES = 'Accessories';
export const ACTIVITY_NAME_CREDIT_APPLICATION = 'CreditApplication';
export const ACTIVITY_NAME_DOC_UPLOAD = 'DocumentUpload';
export const ACTIVITY_NAME_INCENTIVES = 'Incentives';
export const ACTIVITY_NAME_OFFER = 'Offer';
export const ACTIVITY_NAME_TEST_DRIVE = 'TestDrive';
export const ACTIVITY_NAME_TRADE_IN = 'TradeIn';
export const ACTIVITY_NAME_VEHICLE_PROTECTION = 'VehicleProtectionProducts';
export const ACTIVITY_NAME_VEHICLE_RESERVATION = 'VehicleReservation';
